<template>
  <div class="login_container">
    <div class="login_title">康迈名片管理后台</div>
    <div class="login_cont">
      <div class="login_bgm">
        <div class="login_bgs">
          <div class="login_box">
            <div class="box_title">用户登录</div>
            <!-- 登录表单区域 -->
            <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="100px" class="login_form">
              <!-- 手机号 -->
              <el-form-item prop="phoneno" label="手机号">
                <el-input v-model="loginForm.phoneno"></el-input>
              </el-form-item>
              <!-- 密码 -->
              <el-form-item prop="password" label="密码">
                <el-input v-model="loginForm.password" type="password"></el-input>
              </el-form-item>
              <!-- 密码 -->
              <el-form-item prop="verifycode" label="验证码">
                <el-input v-model="loginForm.verifycode" style="width: 50%;vertical-align: super;"></el-input>
                <div style="width:30%;float:right;margin-right: 8%;text-align: center;">
                  <el-image :src="imgurl" class="s-canvas"></el-image>
                  <div class="changeCode" @click="updateVerifyCode">
                    看不清？换一张
                  </div>
                </div>
              </el-form-item>
              <!-- 按钮区域 -->
              <el-form-item class="btns">
                <el-button type="primary" @click.native.prevent="handleLogin">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { hex, hex_hmac } from '../utils/hex.js'
export default {
  data() {
    // 验证手机号的规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (regMobile.test(value)) {
        return cb()
      }
      cb(new Error('请输入合法的手机号'))
    }
    var validateCode = (rule, value, callback) => {
      if (this.loginForm.verifycode !== value) {
        callback(new Error('请输入正确的验证码'))
      } else {
        callback()
      }
    }

    return {
      imgurl: 'https://vcard.c380.cn/admin/Index/getSigninVerifycode',
      loginForm: {
        phoneno: '',
        password: '',
        verifycode: ''
      },
      // 这是表单的验证规则对象
      loginFormRules: {
        // 验证用户名是否合法
        phoneno: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        verifycode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateCode, trigger: 'blur' }
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {},
  methods: {
    updateVerifyCode() {
      this.imgurl = 'https://vcard.c380.cn/admin/Index/getSigninVerifycode?' + Math.random()
    },
    handleLogin() {
      this.$refs.loginFormRef.validate(valid => {
        if (valid) {
          const _data = {
            ...this.loginForm,
            password: hex_hmac(this.loginForm.phoneno, hex(this.loginForm.password))
          }
          // this.loginForm.password = hex_hmac(this.loginForm.phoneno, hex(this.loginForm.password))
          this.$axios.post('/admin/Index/checkSignin', _data).then(res => {
            if (res.data.rst == 0) {
              this.$router.push({ path: '/console' })
            } else {
              this.alertError(res.data.msg)
            }
          }).catch(err => {
            console.error('错误：', err)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 成功弹窗
    alertSuccess(msg) {
      this.$message.success({
        showClose: true,
        duration: 1000,
        message: msg,
        type: 'success'
      })
    },
    // 错误消息
    alertError(msg) {
      this.$message.error({
        duration: 10000,
        showClose: true,
        message: msg,
        type: 'error'
      })
    }
  }
}
</script>

<style lang="less">
  .login_container {
    background-color: #242635;
    height: 100%;
    overflow: hidden;

    .login_cont {
      width: 100%;
      height: 768px;
      display: flex;
      justify-content: center;
      align-items: center;

      .login_bgm {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 960px;
        height: 680px;
        background: rgba(255, 255, 255, .1);
        border-radius: 30px;

        .login_bgs {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 800px;
          height: 600px;
          background: rgba(255, 255, 255, .1);
          border-radius: 30px;
        }
      }
    }

    .login_title {
      font-size: 56px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      padding-top: 120px;
    }

    .box_title {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #222222;
      text-align: center;
      margin: 40px;
    }
  }

  .login_box {
    width: 680px;
    height: 480px;
    background: #FFFFFF;
    border-radius: 30px;
  }

  .login_form {
    display: flex;
    align-items: center;
    flex-direction: column;

    .el-form-item {
      margin-bottom: 20px;
      width: 80%;
    }

    .el-form-item>.el-form-item__label {
      line-height: 50px !important;
    }

    .el-form-item__content {
      line-height: 50px !important;

      .el-input {
        .el-input__inner {
          line-height: 50px !important;
          height: 50px !important;
        }
      }

    }
  }

  .s-canvas {
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
    border-radius: 4px;
    width: 130px;
    overflow: hidden;
  }

  .changeCode {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    text-decoration: underline;
    color: #2E52E4;
    text-align: right;
    cursor: pointer;
  }

  .btns {

    /*margin-top: -32px;*/
    .el-button {
      width: 100%;
    }
  }
</style>
